import Masonry from 'masonry-layout';
window.Masonry = Masonry;
